import { Periodo } from "shared/models/Periodo";

export class CardReportRequest {
  cardNumber: string;
  rubroId: number;
  anio: number;
  mes: number;

  constructor(data: {
    tarjeta: string,
    rubroId?: number,
    selectdate?: Periodo,
  }) {
    this.cardNumber = data.tarjeta;
    this.rubroId = data.rubroId;
    this.anio = data.selectdate?.anio || new Date().getFullYear();
    this.mes = data.selectdate?.mes || new Date().getMonth() + 1;
  }
}
